import { datadogRum } from "@datadog/browser-rum";

/**
 * Safely adds a custom timing marker to Datadog RUM.
 * No-ops if RUM is not initialized (e.g. localhost, tests).
 */
export function addRumTiming(name: string): void {
  if (datadogRum.getInitConfiguration()) {
    datadogRum.addTiming(name);
  }
}
